import React from "react";
import Image from "next/image";
import styles from "./card.module.css";
import { PaperComponent } from "@/components";
import { CurrencyConverter } from "@/lib/constants";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const ProductCard = ({ title, icon, loanAmount, comingSoon = false }) => {
  const t = useTranslations("Dashboard");
  return (
    <Stack
      height={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      mx={2}
      position={"relative"}
    >
      <PaperComponent className={styles["product-card"]} disabled={comingSoon}>
        <Box className={styles.tag}>
          <Typography color={"#4D6767"}>
            {CurrencyConverter(loanAmount)}
          </Typography>
        </Box>
        <Stack rowGap={2}>
          <Image src={icon} alt="title" width={60} height={60} />
          <Typography variant="h5">
            {t(
              title
                ?.replaceAll("/n", "")
                ?.replaceAll(" ", "")
                ?.replaceAll("\n", "")
                ?.toLowerCase(),
            )}
          </Typography>
        </Stack>
      </PaperComponent>
      {comingSoon && (
        <Typography
          variant="h5"
          sx={{
            position: "absolute",
            height: "100%",
            width: "100%",
            textAlign: "center",
            alignContent: "center",
            cursor: "not-allowed",
          }}
        >
          {t("comingsoon")}
        </Typography>
      )}
    </Stack>
  );
};

export default ProductCard;
